import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { commonUpdate } from "../../../redux/reducers/putApiSlice";
import {
  addLeaveCategory,
  updateLeaveCategory,
} from "../../../data/ApiEndpoints";

const AdminLeaveForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);

  const iniFormValues = [
    {
      leaveCatName: rowData?.name || "",
      noOfLeaveDays: rowData?.no_ofdays || 0,
      daysBefore: rowData?.days_before || 0,
      isPaidLeave:
        rowData?.is_paid === 1 ? true : rowData?.is_paid === 0 ? false : false,
      isApprovalRequired:
        rowData?.approval_required === 1
          ? true
          : rowData?.approval_required === 0
          ? false
          : false,
      isDocRequired:
        rowData?.doc_required === 1
          ? true
          : rowData?.doc_required === 0
          ? false
          : false,
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
    setIsSubmit(false);
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.leaveCatName) {
      errors.leaveCatName = "Leave category name is required!";
    }

    if (!formValues.noOfLeaveDays) {
      errors.noOfLeaveDays = "No of days is required!";
    }

    if (!formValues.daysBefore) {
      errors.daysBefore = "Days before is required!";
    }

    return errors;
  };

  const handleAdd = async (requestBody) => {
    const method = "POST";
    const endpoint = addLeaveCategory;
    const payload = requestBody;
    const token = userInfoData?.token || "";

    try {
      const result = rowData?.uid
        ? await dispatch(
            commonUpdate({
              endPoint: updateLeaveCategory,
              requestBody: payload,
              filters: "",
              TOKEN: token,
            })
          )
        : await dispatch(fetchApiData({ method, endpoint, payload, token }));

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      leaveCatName: rowData?.name || "",
      noOfLeaveDays: rowData?.no_ofdays || 0,
      daysBefore: rowData?.days_before || 0,
      isPaidLeave:
        rowData?.is_paid === 1 ? true : rowData?.is_paid === 0 ? false : false,
      isApprovalRequired:
        rowData?.approval_required === 1
          ? true
          : rowData?.approval_required === 0
          ? false
          : false,
      isDocRequired:
        rowData?.doc_required === 1
          ? true
          : rowData?.doc_required === 0
          ? false
          : false,
    }));
  }, [rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.leaveCatName,
        no_ofdays: formValues.noOfLeaveDays,
        days_before: formValues.daysBefore,
        is_paid: formValues.isPaidLeave ? 1 : 0,
        approval_required: formValues.isApprovalRequired ? 1 : 0,
        doc_required: formValues.isDocRequired ? 1 : 0,
      };

      if (rowData?.uid) {
        userData.uid = rowData.uid;
      }

      handleAdd(userData);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox">
            <label htmlFor="leaveCatName" className={`formInputLabel `}>
              Leave Category Name *
            </label>

            <input
              type="text"
              placeholder="Enter Leave Category Name"
              className={`formInput ${
                formErrors?.leaveCatName ? "formError" : ""
              }`}
              name="leaveCatName"
              value={formValues.leaveCatName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="noOfLeaveDays" className={`formInputLabel `}>
              No Of Leave Days In A Month *
            </label>

            <input
              type="number"
              placeholder="Enter  No Of Leave Days"
              className={`formInput ${
                formErrors?.noOfLeaveDays ? "formError" : ""
              }`}
              name="noOfLeaveDays"
              value={formValues.noOfLeaveDays}
              onChange={onChangeInput}
              min="0"
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="daysBefore" className={`formInputLabel `}>
              Apply Days Before *
            </label>

            <input
              type="number"
              placeholder="Enter Apply Days Before"
              className={`formInput ${
                formErrors?.daysBefore ? "formError" : ""
              }`}
              name="daysBefore"
              value={formValues.daysBefore}
              onChange={onChangeInput}
              min="0"
            />
          </div>
        </div>

        <div className={`commonWrapper switchs-input-container leave-switches mt30 mt-sm-0`}>
          <Form.Check
            type="switch"
            name="isPaidLeave"
            className={`${formErrors?.isPaidLeave ? "formError" : ""}`}
            label={`${formValues.isPaidLeave ? "Paid" : "Unpaid"}`}
            checked={formValues.isPaidLeave}
            onChange={onChangeInput}
          />
          <Form.Check
            type="switch"
            name="isApprovalRequired"
            className={`${formErrors?.isApprovalRequired ? "formError" : ""}`}
            label={`${
              formValues.isApprovalRequired
                ? "Approval Required"
                : "Approval Not Require"
            }`}
            checked={formValues.isApprovalRequired}
            onChange={onChangeInput}
          />
          <Form.Check
            type="switch"
            name="isDocRequired"
            className={`${formErrors?.isDocRequired ? "formError" : ""}`}
            label={`${
              formValues.isDocRequired
                ? "Document Required"
                : "Document Not Required"
            }`}
            checked={formValues.isDocRequired}
            onChange={onChangeInput}
          />
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {loading ? <ReactVortoxSpinner /> : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AdminLeaveForm;
